const defaultRender = (value) => (value ? value : '--');

const columns = [
    {
        title: 'Name',
        dataIndex: 'name',
        render: defaultRender,
    },
    {
        title: 'Charge',
        dataIndex: 'charge',
        render: defaultRender,
    },
    {
        title: 'Pipeline',
        dataIndex: 'pipeline_temp_name',
        render: defaultRender,
    },
    {
        title: 'Action',
        dataIndex: 'actions',
        render: defaultRender,
    },
];

export default columns;